
import { Routes } from 'react-router-dom';
import { Suspense } from 'react';
import { LoadingState } from '../components/ui/loading-state';
import { PublicRoutes } from './PublicRoutes';
import { LandingRoutes } from './LandingRoutes';
import { AuthenticatedRoutes } from './AuthenticatedRoutes';
import NotFound from '../pages/NotFound';
import { FeedbackChatProvider } from '@/contexts/FeedbackChatContext';
import { EnhancedFeedbackSystem } from '@/components/feedback/EnhancedFeedbackSystem';
import { Route } from 'react-router-dom';
import EntryRoute from '../components/routing/EntryRoute';

const PageLoading = () => (
  <LoadingState
    title="Loading page"
    description="Please wait while we prepare your content..."
    fullScreen={true}
  />
);

export const AppRouter = () => {
  return (
    <FeedbackChatProvider>
      <Suspense fallback={<PageLoading />}>
        <Routes>
          {/* Entry route - handles root path routing decisions */}
          <Route path="/" element={<EntryRoute />} />
          {PublicRoutes}
          {LandingRoutes}
          {AuthenticatedRoutes}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
      <EnhancedFeedbackSystem />
    </FeedbackChatProvider>
  );
};
